
import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import { AuthenticationService } from './../services/authentication.service';
import { Observable } from 'rxjs';

import * as appConfig from '../../app.config';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = AuthenticationService.getBearerToken();
        const headers = {
            'Content-Type': 'application/json'
        };
        if (token) {
            headers['Authorization'] = `Bearer ${AuthenticationService.getBearerToken()}`;
        }
        request = request.clone({
            url: appConfig.apiUrl + request.url,
            setHeaders: headers
        });
        return next.handle(request);
    }
}
